import {Box, Stack, styled} from '@mui/material';

const ProfileContainer = styled(Box)`
	padding: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}
`;

const CustomBox = styled(Stack)`
	padding: 16px;
	border-radius: 8px;
	gap: 16px;

	background-color: ${({theme}) => theme.colors.brand.primary.white};
`;

export {ProfileContainer, CustomBox};
